import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-domain-notification',
  templateUrl: './no-domain-notification.component.html',
  styleUrls: ['./no-domain-notification.component.scss']
})
export class NoDomainNotificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
